<template>
  <div id="helper">
    <div id="sizeSpec" class="d-flex justify-content-center align-items-center">
      <div class="d-block d-sm-none">XS</div>
      <div class="d-none d-sm-block d-md-none">SM</div>
      <div class="d-none d-md-block d-lg-none">MD</div>
      <div class="d-none d-lg-block d-xl-none">LG</div>
      <div class="d-none d-xl-block">XL</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BootstrapSizeHelper"
}
</script>

<style lang="scss" scoped>
 #helper {
   position: fixed;
   bottom: 0;
   left: 0;
   width: 100%;
   height: 50px;
   z-index: 10001;
 }

 #sizeSpec {
   position: absolute;
   right: 0;
   height: 50px;
   width: 50px;
   background-color: white;
   border-radius: 5px;
   color: black;
   font-weight: bold;
   border: 3px solid black;
 }
</style>
